import { GetTenantModel } from "@factory/model/query-model-tenant";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { tenantFormDefault } from "./form.default";
import { TenantFormSchema } from "./form.rule";

export const useFormDefaultTenant = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTenantModel | undefined) => {
    return !cachedValue
      ? tenantFormDefault
      : ({
          owner: cachedValue.owner,
          businessName: cachedValue.business_name,
          businessType: cachedValue.business_type,
          description: cachedValue.description,
          avatar: cachedValue.avatar,
          email: cachedValue.email,
          mobileNumber: cachedValue.mobile_number,
          phoneNumber: cachedValue.phone_number,
          website: cachedValue.website,
          membershipDate: formatDate(cachedValue.membership_date) as any,
          rewardsType: cachedValue.rewards_type,
          postRegistrationLink: cachedValue.post_registration_link,
          postRegistrationMessage: cachedValue.post_registration_message,
          allowUnderEighteen: cachedValue.allow_under_eighteen,
          allowDecimalPoints: cachedValue.allow_decimal_points,
          featureQuota: cachedValue.feature_quota,
          featureSplashScreen: cachedValue.feature_splash_screen,
          featureCoupon: cachedValue.feature_coupon,
          featureReferral: cachedValue.feature_referral,
          featureBirthdayEmail: cachedValue.feature_birthday_email,
          smtpAppPassword: cachedValue.smtp_app_password,
          smtpMailUser: cachedValue.smtp_mail_user,
          smtpMailFrom: cachedValue.smtp_mail_from,
          smtpMailContent: cachedValue.smtp_mail_content,
          termsAndConditions: cachedValue.terms_and_conditions,
          privacyPolicy: cachedValue.privacy_policy,
        } as TenantFormSchema);
  };

  return {
    getDefault,
  };
};
